import mixpanel from 'mixpanel-browser';
import type { SiteType } from '../context/page-context';

export function trackUpgradeClicked(site: SiteType, location: string) {
  try {
    mixpanel.track('Upgrade Clicked', {
      site_id: site.siteId,
      site_env: site.siteEnv,
      location,
    });
  } catch {
    // Silently fail if Mixpanel is not initialised
  }
}

export interface Dict {
  [key: string]: unknown;
}

export function track(site: SiteType, event: string, data: Dict) {
  try {
    mixpanel.track(event, {
      site_id: site.siteId,
      site_env: site.siteEnv,
      ...data,
    });
  } catch {
    // Silently fail if Mixpanel is not initialised
  }
}
